import { t } from 'i18next';
import { seebizCloudUrl } from '../Helpers/UrlHelper';
const seebizUrl = seebizCloudUrl();

const UserManual = [
  {
    label: 'UserManual.registration',
    value: '1.',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-register-with-seebiz-inventory/`,
  },
  {
    label: 'UserManual.managing_businesses',
    value: '2.',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-multiple-businesses-and-warehouses/`,
  },
  {
    label: 'UserManual.creating_contacts',
    value: '3.',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-a-new-contact/`,
  },
  {
    label: 'UserManual.import_export_contacts',
    value: '3.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-import-export-contacts/`,
  },
  {
    label: 'UserManual.managing_contacts',
    value: '3.2',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-contacts/`,
  },
  {
    label: 'UserManual.vendor_contact_details',
    value: '3.3',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-contact-details-for-a-vendor/`,
  },
  {
    label: 'UserManual.customer_contact_details',
    value: '3.4',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-contact-details-for-a-customer/`,
  },
  {
    label: 'UserManual.creating_items',
    value: '4',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-an-item/`,
  },
  {
    label: 'UserManual.import_export_items',
    value: '4.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-import-export-items/`,
  },
  {
    label: 'UserManual.managing_items',
    value: '4.2',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-items/`,
  },
  {
    label: 'UserManual.vendor_item_details',
    value: '4.3',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-items-details/`,
  },
  {
    label: 'UserManual.creating_item_adjustments',
    value: '5',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-item-adjustments/`,
  },
  {
    label: 'UserManual.managing_item_adjustments',
    value: '5.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-item-adjustment/`,
  },
  {
    label: 'UserManual.item_adjustment_details',
    value: '5.2',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-item-adjustments-details/`,
  },
  {
    label: 'UserManual.creating_sales_orders',
    value: '6',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-sales-order/`,
  },
  {
    label: 'UserManual.creating_packages',
    value: '6.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-a-package/`,
  },
  {
    label: 'UserManual.creating_shipments',
    value: '6.2',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-a-shipment/`,
  },
  {
    label: 'UserManual.managing_sales_orders',
    value: '7',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-sales-order/`,
  },
  {
    label: 'UserManual.managing_packages',
    value: '7.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-packages-export-and-all/`,
  },
  {
    label: 'UserManual.sales_order_details',
    value: '7.2',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-sales-order-details/`,
  },
  {
    label: 'UserManual.package_details',
    value: '7.3',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-package-details/`,
  },
  {
    label: 'UserManual.create_backorder',
    value: '8',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-a-backorder-for-a-sales-order/`,
  },
  {
    label: 'UserManual.dropshipping',
    value: '9',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-dropship-a-sales-order/`,
  },
  {
    label: 'UserManual.creating_invoices',
    value: '10',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-invoices/`,
  },
  {
    label: 'UserManual.managing_invoices',
    value: '10.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-invoices-export-and-all/`,
  },
  {
    label: 'UserManual.invoice_details',
    value: '10.2',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-invoice-details/`,
  },
  {
    label: 'UserManual.creating_sales_returns',
    value: '11',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-sales-return/`,
  },
  {
    label: 'UserManual.managing_sales_returns',
    value: '11.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-sales-return-export-and-all/`,
  },
  {
    label: 'UserManual.sales_return_details',
    value: '11.2',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-sales-return-details/`,
  },
  {
    label: 'UserManual.credit_notes',
    value: '12',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-credit-notes/`,
  },
  {
    label: 'UserManual.manage_credit_notes',
    value: '12.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-credit-notes-export-and-all/`,
  },
  {
    label: 'UserManual.creating_purchase_orders',
    value: '13',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-purchase-order/`,
  },
  {
    label: 'UserManual.managing_purchase_orders',
    value: '13.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-purchase-order/`,
  },
  {
    label: 'UserManual.purchase_order_details',
    value: '13.2',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-purchase-order-details/`,
  },
  {
    label: 'UserManual.creating_bills',
    value: '14',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-bills/`,
  },
  {
    label: 'UserManual.managing_bills',
    value: '14.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-bills/`,
  },
  {
    label: 'UserManual.bill_details',
    value: '14.2',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-bill-details/`,
  },
  {
    label: 'UserManual.view_manage_reports',
    value: '15',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-view-and-manage-reports/`,
  },
  {
    label: 'UserManual.users_and_roles',
    value: '16',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-invite-users-and-create-roles-in-settings/`,
  },
  {
    label: 'UserManual.create_manage_taxes',
    value: '16.1.1',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-and-manage-taxes/`,
  },
  {
    label: 'UserManual.delivery_methods',
    value: '16.1.2',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-and-manage-delivery-methods/`,
  },
  {
    label: 'UserManual.inventory_accounts',
    value: '16.1.4',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-create-and-manage-inventory-account/`,
  },
  {
    label: 'UserManual.managing_preferences',
    value: '16.1.6',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-manage-preferences/`,
  },
  {
    label: 'UserManual.navigating_seebiz_inventory',
    value: '17',
    url: `www.${seebizUrl}/inventory/user-manual/how-to-access-quick-navigations/`,
  },
  {
    label: 'UserManual.dashboard_overview',
    value: '18',
    url: `www.${seebizUrl}/inventory/user-manual/analyzing-your-inventory-summary-through-dashboard/`,
  },
];

export default UserManual;
